<template>
  <router-view />
</template>

<script>
    export default {
        name: "ProjectContainer"
    }
</script>